export const PermissionKeys = {
  TOUR_CRITERIA: 'SURF_TOUR_CRITERIA'
};
